import React from "react";
import { component_tool } from "@/tool";

const { WizDropdown, WizMenu, WizIcon } = component_tool;

export default function(initialValue = {}) {
  return [
    {
      name: "entityId",
      formItem: {
        type: "hidden",
        initialValue: initialValue.id,
      },
    },
    {
      title: '名称',
      name: 'entityName',
      tableItem: {
        width: 130
      }
    },
    {
      title: '类型',
      name: 'entityType',
      tableItem: {
        width: 150,
      },
      dict: this.config.map(val => ({ code: val.key, codeName: val.title }))
    },
    {
      title: '开始时间',
      name: 'entityStartTime',
      tableItem: { }
    },
    {
      title: '结束时间',
      name: 'entityEndTime',
      tableItem: { }
    },
    {
      title: '状态',
      name: 'entityStateName',
      tableItem: { },
      // dict: [
      //   { code: 0, codeName: '已结束' },
      //   { code: 1, codeName: '已发布' },
      // ]
    },
    {
      title: '操作',
      name: 'oprate',
      tableItem: {
        width: 150,
        render: (text, record, index) => <a onClick={ () => this.handleDelete(index) }>删除</a>
      }
    },
  ]
}